import { render, staticRenderFns } from "./BillItem.vue?vue&type=template&id=5f1c842d&scoped=true&"
import script from "./BillItem.vue?vue&type=script&lang=js&"
export * from "./BillItem.vue?vue&type=script&lang=js&"
import style0 from "./BillItem.vue?vue&type=style&index=0&id=5f1c842d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1c842d",
  null
  
)

export default component.exports